module.exports = __webpack_public_path__ + "img/16.0fbffc72.jpeg";